<template>
    <v-card>
        <v-card-title>
        <span class="headline">Cargo Packaging Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newPack">
                <v-text-field :label="labels.pack" v-model="packForm.pack" :error-messages="errors.collect('pack')" data-vv-name="pack" :data-vv-as="labels.pack" v-validate="'required|param|max:8'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.pack}}</v-subheader>
                <div class="title">{{packForm.pack}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="packForm.packDesc" :label="labels.packDesc" :error-messages="errors.collect('packDesc')" v-validate="'required|entry|max:100'" data-vv-name="packDesc" :data-vv-as="labels.packDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'packForm': Object,
    'newPack': Boolean
  },
  data() {
    return {
      labels: {
        pack: 'Packaging Code*',
        packDesc: 'Packaging Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.packForm.pack = undefined
      this.packForm.packDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPack) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.cargo.menu.createPack
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.packForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.cargo.menu.updatePack
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.packForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
